export default "__VITE_ASSET__U$lWSYva__"